import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppStateSelector, pick } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { productImagePlaceholder, trendingCollections } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const { format } = useCurrencyFormatting();
    const { query, response } = useAppStateSelector(state =>
        pick(state, "query", "response")
    )

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    // console.log(keywords);

    useEffect(()=>{
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "ns-ac-banner" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    return (
        <div
            class="ns-autocomplete ns-autocomplete-ac ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-row">
                {/* ns-justify-content-between */}
                    <div class={`ns-autocomplete-left-part ns-d-flex ns-flex-column ns-col-6 ${
                                    products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                                }`}>
                        {keywords?.hits?.length > 0 && (
                            <div
                                class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}
                            >
                                {/* ns-py-2 ns-px-4 */}
                                <div class="ns-color-black ns-font-bold ns-font-4 ns-autocomplete-heading">
                                    Suggestions
                                </div>
                                <div class="ns-d-flex ns-flex-column">
                                    <Keywords
                                        hits={keywords.hits}
                                        keywordComponent={Keyword}
                                        elementComponent={Element}
                                        keywordInCategoryComponent={KeywordInCategory}
                                    />
                                </div>
                                {!products?.hits?.length && <SubmitButton text="See all search results" />}
                            </div>
                        )}
                       {trendingCollections && <div
                            class={`ns-autocomplete-brands ns-d-flex ns-flex-column`}
                        >
                            {/* ns-py-2 ns-px-4 */}
                            <div class="ns-color-black ns-font-bold ns-font-4 ns-autocomplete-heading">
                                Brands
                            </div>
                            <div class="ns-d-flex ns-flex-column">
                                {(window.nostoTrendingCollections || trendingCollections).map(item => (
                                    <a class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-px-4 ns-py-2 ns-font-4 ns-text-undecorated" href={item?.url}>
                                        {item?.name}
                                    </a>
                                ))}
                            </div>
                        </div>}
                    </div>
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="nosto_element" id="ns-ac-banner"></div>
                            <div class="ns-d-flex ns-autocomplete-products-container">
                                {products?.hits?.map(hit => {
                                    // console.log(hit);
                                    const isPriceHidden = hit?.customFields?.find(field => field?.key === "price hidden")?.value === "Yes";
                                    return (
                                        <AutocompleteElement key={hit.productId} hit={hit}>
                                            <article class="ns__result ns__result--grid ns__results__result">
                                                <div class="ns__result__image-wrapper">
                                                    <a href={hit?.url}>
                                                        <div class="ns__image ns__result__image">
                                                            <img src={hit?.thumbUrl} alt={hit?.name} title={hit?.name} loading="lazy" />
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="ns__result__details">
                                                    <div class="ns__result__details__title">
                                                        <a href={hit?.url} class="ns-text-undecorated">{hit?.name}</a>
                                                    </div>
                                                   {!isPriceHidden && <div class="card-text card_price ns__result__pricing" data-test-info-type="price">
                                                        {hit?.listPrice > hit?.price && <div class="price-section price-section--withoutTax rrp-price--withoutTax ns__result__msrp ">
                                                            <span data-product-rrp-price-without-tax="true" class="price price--rrp ns-text-striked">{format(hit?.listPrice)}</span>
                                                        </div>}
                                                        <div class="price-section price-section--withoutTax ns__result__price">
                                                            <span class="price-label"></span>
                                                            <span class="price-now-label" style="display: none;"></span>
                                                            <span data-product-price-without-tax="true" class="price price--withoutTax">{format(hit?.price)}</span>
                                                        </div>
                                                    </div>}
                                                </div>
                                            </article>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            <SubmitButton text={`See ${response?.products?.total} results for "${query?.query}"`} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}

{/* <div
                                                data-url={hit.url}
                                                class="ns-d-flex flex-row ns-clickable ns-p-2"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="ns-h-auto ns-object-contain"
                                                    src={hit.imageUrl ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="60"
                                                    height="40"
                                                />
                                                <div class="ns-pl-2">
                                                    {hit.brand && (
                                                        <div class="ns-color-black ns-mb-1 ns-font-4">{hit.brand}</div>
                                                    )}
                                                    <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
                                                        {hit.name}
                                                    </div>
                                                    <div>
                                                        <span>{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div> */}
